/**
 * Email-related message constants
 * Extracted from defaults.js to avoid circular dependency with emails.js tab component
 */
const EmailMessages = {
	CONFIRMATION_MESSAGE: 'Thank you. Your response has been recorded.',
	SUBMISSION_EMAIL_CONFIRMATION_MESSAGE: '<p>Thank you. We\'ve received and recorded your completed form with signature.</p>',
	SUBMISSION_RESPONSE_SIGNATURE_CONFIRMATION_MESSAGE: '<p>Thank you. We\'ve received and recorded your completed form with signature.</p><p>A copy of the signed form will be sent to the confirmation email address you provided.</p>',
};

export default EmailMessages;


// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/shared/constants/email-messages.js